<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center" color="primary">
    <span>
        Excel Import
    </span>
    <button [attr.guide]="'import-excel-btn-1' + '__' + sanitizedUrl" mat-icon-button>
    <mat-icon (click)="close()">
        close
    </mat-icon>
</button>
</mat-toolbar>
<div class="products-padding " *ngIf="!uploadedFile; else elseBlock" >
   <input [attr.guide]="'import-excel-inp-2' + '__' + sanitizedUrl" [autocomplete]="'off'"type="file" ng2FileSelect [uploader]="uploader"/>

    <mat-dialog-actions align="center">

        <div class="products-padding " fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <button [attr.guide]="'import-excel-btn-3' + '__' + sanitizedUrl" #dummyID mat-raised-button *ngIf="uploader?.queue?.length>0" [disabled]="text !='Upload'"  (click)="upload()">
              {{text}}
              <mat-icon *ngIf="text !='Upload' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
              </mat-icon>
            </button>
        </div>
    </mat-dialog-actions>
</div>

<ng-template #elseBlock>
  <div class="products-padding" fxLayout="column" *ngIf="faliedList.length>0">

    <div fxLayout="row">


        Failure List:

    </div>
    <div fxLayout="row">
        <table fxFlex>
            <tr>
                <th>Name</th>

            </tr>
            <tr *ngFor="let item of faliedList ">
                <td>{{item.name}}</td>

            </tr>

        </table>
    </div>
</div>
</ng-template>
